module.exports = __webpack_public_path__ + "assets/apple-touch-icon-76-devel-a60831.png";